var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 26,
    viewBox: "0 0 56 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#EC6643"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3333,
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#EC6643"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6667,
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#C0C3C9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#EC6643"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3333,
    y: 10,
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#EC6643"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6667,
    y: 10,
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#EC6643"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#EC6643"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.3333,
    y: 20,
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#C0C3C9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6667,
    y: 20,
    width: 17.3333,
    height: 6,
    rx: 2,
    fill: "#C0C3C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/Art.4b7ab3690c988f07888f7fd0a85e3c0e.svg";
export { ForwardRef as ReactComponent };